import { polyfillRequestIdleCallback } from './requestIdleCallbackPolyfill';

export function initPolyfills(): void {
    polyfillRequestIdleCallback();
}
